var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4868 31.3546C4.8478 29.4064 0 23.2693 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 23.2693 27.1522 29.4064 20.5132 31.3546L16.8944 38.5921C16.5259 39.3291 15.4741 39.3291 15.1056 38.5921L11.4868 31.3546Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 29.7137C23.5741 29.7137 29.7142 23.5736 29.7142 15.9994C29.7142 8.42525 23.5741 2.28516 15.9999 2.28516C8.42574 2.28516 2.28564 8.42525 2.28564 15.9994C2.28564 23.5736 8.42574 29.7137 15.9999 29.7137Z",
    fill: "#19A04B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4761 10.5996L20.5713 13.2119V16.7619H19.0475V14.2166L14.4761 12.2575L9.90467 14.2166V16.7619H8.38086V13.2119L14.4761 10.5996Z",
    fill: "#F3F4F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8091 14.4766H17.1424V16.7623H15.6186V16.0004H13.3329V16.7623H11.8091V14.4766Z",
    fill: "#F3F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5712 10.0384V16.7618H19.0474V9.90467H19.8093C19.0474 9.90467 19.0474 9.90392 19.0474 9.90317L19.0474 9.90165L19.0474 9.89853L19.0475 9.89202L19.0478 9.87792C19.0481 9.86804 19.0486 9.85719 19.0494 9.84543C19.051 9.82195 19.0536 9.79468 19.058 9.76418C19.0667 9.70331 19.0823 9.62849 19.1103 9.54469C19.167 9.37443 19.2727 9.17328 19.461 8.98497C19.8448 8.60121 20.4537 8.38086 21.3331 8.38086C22.2124 8.38086 22.8214 8.60121 23.2052 8.98497C23.3935 9.17328 23.4991 9.37443 23.5559 9.54469C23.5838 9.62849 23.5995 9.70331 23.6082 9.76418C23.6125 9.79468 23.6152 9.82195 23.6167 9.84543C23.6175 9.85719 23.618 9.86804 23.6184 9.87792L23.6187 9.89202L23.6188 9.89853L23.6188 9.90165L23.6188 9.90317C23.6188 9.90392 23.6188 9.90467 22.8569 9.90467H23.6188V16.7618H22.095V10.0384C22.0712 10.0239 22.0326 10.0044 21.9731 9.98462C21.8539 9.9449 21.6528 9.90467 21.3331 9.90467C21.0133 9.90467 20.8122 9.9449 20.6931 9.98462C20.6336 10.0044 20.595 10.0239 20.5712 10.0384Z",
    fill: "#F3F4F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.619 19.0472H8.38086V17.5234H23.619V19.0472Z",
    fill: "#F3F4F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.619 21.3344H8.38086V19.8105H23.619V21.3344Z",
    fill: "#F3F4F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.619 23.6195H8.38086V22.0957H23.619V23.6195Z",
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/Web.5ee21c400e208c19b77bef3abedaa859.svg";
export { ForwardRef as ReactComponent };